import VideoCategoryData from './VideoCategoryData'

class VideoCategoryList {

    initialized = false;

    constructor(result) {

        this.videoCategoryList = {};

        if (result) {
            for (let categoryName in result) {
                this.videoCategoryList[categoryName] = [];

                for(let ix = 0; ix < result[categoryName].length;ix++) {
                    const v = new VideoCategoryData(result[categoryName][ix]);

                    this.videoCategoryList[categoryName].push(v);
                }

                /* Auskommentiert weil der IE Blöd ist!
                for (let ix in result[categoryName]) {
                    if(ix==="find")return;

                    let v = new VideoCategoryData(result[categoryName][ix]);

                    this.videoCategoryList[categoryName].push(v);
                }
                */
            }

            this.initialized = true;
        }

    }

    getVideoList() {

        return this.videoCategoryList();

    }

    getVideoCategoryDataById(categoryId) {

        for (let ix in this.videoCategoryList) {
            let c = this.videoCategoryList[ix];

            if (+(c.categoryId) === +(categoryId)) return c;
        }

        return [];

    }

}

export default VideoCategoryList;